import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, useI18n} from "shared/base"
import React, {useEffect, useMemo} from "react"
import HayaSelect from "components/woof-haya-select"
import {Plan} from "models"
import {useForm} from "@kaspernj/api-maker/build/form"
import {withSelectContainer as withAdminSelectContainer} from "components/admin/select-container"

/**
 * @typedef {object} ComponentsContactsPlansFilterSelectInnerProps
 * @property {unknown} qParams
 */

/**
 * @typedef {object} ComponentsContactsPlansFilterSelectInnerState
 * @property {unknown} plan
 */

/**
 * @extends {ShapeComponent<ComponentsContactsPlansFilterSelectInnerProps, ComponentsContactsPlansFilterSelectInnerState>}
 */
class ComponentsContactsPlansFilterSelectInner extends ShapeComponent {
  /** @type {ComponentsContactsPlansFilterSelectInnerState} */
  state = {
    plan: undefined
  }

  static propTypes = propTypesExact({
    qParams: PropTypes.object.isRequired
  })

  setup() {
    const {t} = useI18n({namespace: "js.components.contacts.plans_filter_select"})

    this.defaultValues = useMemo(() => {
      let planId
      const {qParams} = this.p
      const withAnySubscriptionParamRaw = qParams.with_any_subscription

      if (withAnySubscriptionParamRaw) {
        const withAnySubscriptionParam = JSON.parse(withAnySubscriptionParamRaw)

        planId = withAnySubscriptionParam.plan_ids[0]
      }

      if (planId) {
        return [planId]
      } else if (qParams.without_any_subscription) {
        return ["no_active_subscription"]
      }
    }, [])

    const form = useForm()

    this.form = form
    this.t = t


    useEffect(() => () => {
      if (form) {
        form.unsetValue("with_any_subscription")
        form.unsetValue("without_any_subscription")
      }
    }, [form])
  }

  render() {
    const {defaultValues} = this.tt

    return (
      <HayaSelect
        className="components/contacts/plans-filter-select"
        defaultValues={defaultValues}
        onChange={this.tt.onChange}
        options={this.tt.optionsCallback}
      />
    )
  }

  onChange = ({options}) => {
    const option = options[0]

    if (option.value == "no_active_subscription") {
      this.tt.form.setValue("with_any_subscription", undefined)
      this.tt.form.setValue("without_any_subscription", 1)
    } else {
      this.tt.form.setValue("with_any_subscription", JSON.stringify({plan_ids: [option.plan.id()]}))
      this.tt.form.setValue("without_any_subscription", undefined)
    }
  }

  optionsCallback = async ({query, searchValue, values}) => {
    const {t} = this.tt

    query = (query?.clone() || Plan)
      .ransack({
        s: "current_translation_name asc",
        identifier_not_eq: "free"
      })
      .select({Plan: ["id", "name"]})
      .limit(20)

    if (searchValue) query.ransack({current_translation_name_cont_any_word: searchValue})
    if (values) query.ransack({id_eq_any: values})

    const plans = await query.toArray()
    const planOptions = plans.map((plan) => ({
      plan,
      text: plan.name(),
      value: plan.id()
    }))

    let options = [
      {
        text: t(".no_active_subscription"),
        value: "no_active_subscription"
      }
    ].concat(planOptions)

    if (searchValue) {
      options = options.filter((option) => option.text.toLowerCase().includes(searchValue.toLowerCase()))
    }

    if (values) {
      options = options.filter((option) => values.includes(option.value))
    }

    return options
  }
}

const ComponentsContactsPlansFilterSelect = memo(shapeComponent(ComponentsContactsPlansFilterSelectInner))

const AdminSelect = withAdminSelectContainer(ComponentsContactsPlansFilterSelect)

export {AdminSelect}
export default ComponentsContactsPlansFilterSelect
